import type { ImportedTopologySource } from '../../imported-model/loaders/types'
import { rebaseImportedTopologySourceOccurrence } from '../../imported-model/utils'

/**
 * 把完整 GLB 中的源 occurrence 拓扑身份重绑定为项目运行时 occurrence 身份。
 *
 * 该函数只重建 occurrence 相关的索引和值对象；primitive、mesh、BRep 引用和 MeshData
 * 都继续共享源 definition 资产，避免同一零件多实例产生重复内存。
 *
 * @param input 源拓扑表与项目运行时身份映射。
 * @returns 仅以项目运行时 assemblyNodeId 为 key 的拓扑源索引。
 */
export function rebaseProjectModelImportedTopologySources(
  input: PuppyCAD.RebaseProjectModelImportedTopologySourcesInput,
): ReadonlyMap<string, ImportedTopologySource> {
  const result = new Map<string, ImportedTopologySource>()

  input.sourceByAssemblyNodeId.forEach((source, sourceAssemblyNodeId) => {
    const runtimeAssemblyNodeId = input.runtimeAssemblyNodeIdBySourceAssemblyNodeId
      .get(sourceAssemblyNodeId)
      ?.trim()
    if (!runtimeAssemblyNodeId) {
      throw new Error(`拓扑源缺少运行时 occurrence 身份映射：source=${sourceAssemblyNodeId}`)
    }
    if (result.has(runtimeAssemblyNodeId)) {
      throw new Error(
        `拓扑源运行时 occurrence 身份冲突：runtime=${runtimeAssemblyNodeId}, source=${sourceAssemblyNodeId}`,
      )
    }

    result.set(
      runtimeAssemblyNodeId,
      rebaseImportedTopologySourceOccurrence(source, runtimeAssemblyNodeId),
    )
  })

  return result
}
